import React, { useEffect, useState } from 'react';
import { object, string, bool, func, oneOfType } from 'prop-types';
import {
  StyledContainer,
  HiddenCheckbox,
  StyledCheckBox,
  StyledBox,
  StyledLabel,
  StyledCheckSvg,
} from 'apps/journey/components/checkbox/styled-checkbox-title';

const CheckboxTitle = (
  { isChecked, name, handleChange, children, disabled },
  props
) => {
  const [checked, setChecked] = useState(isChecked);

  const handleOnChange = (e) => {
    if (!disabled) {
      setChecked(!checked);
      handleChange({ name: name, value: !checked, event: e });
    }
  };

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  return (
    <StyledContainer onClick={handleOnChange} disabled={disabled}>
      <HiddenCheckbox defaultChecked={checked} {...props} />
      <StyledCheckBox checked={checked}>
        <StyledBox checked={checked}>
          <span>{checked && <StyledCheckSvg />}</span>
        </StyledBox>
        <StyledLabel>{children}</StyledLabel>
      </StyledCheckBox>
    </StyledContainer>
  );
};

CheckboxTitle.propTypes = {
  children: oneOfType([object, string]),
  name: string,
  isChecked: bool,
  handleChange: func,
  disabled: bool,
};

export default CheckboxTitle;
